const ru = [
    "Узбекистан",
    "Корея",
    "Россия",
    "Китай",
    "Япония",
    "Австралия",
    "Аргентина",
    "Великобритания",
    "Венгрия",
    "Германия",
    "Гонконг",
    "Дания",
    "Турция",
    "Индия",
    "Испания",
    "Италия",
    "Канада",
    "СССР",
    "США",
    "Украина",
    "Франция"
];

const uz = [
    "O'zbekiston",
    "Koreya",
    "Rossiya",
    "Xitoy",
    "Yaponiya",
    "Avstraliya",
    "Argentina",
    "Buyuk Britaniya",
    "Vengriya",
    "Germaniya",
    "Gonkong",
    "Daniya",
    "Turkiya",
    "Hindiston",
    "Ispaniya",
    "Italiya",
    "Kanada",
    "SSSR",
    "AQSH",
    "Ukraina",
    "Fransiya",
];

const getCountries = () => {
    const countries = ru.map((country, index) => ({
        ru: country,
        uz: uz[index]
    }));

    return countries;
};

export default getCountries;
